<div class="wrapper">
    <div *ngIf="certType == 'ONTOLOGY_CERT'">
        <h1>Unternehmen zertifizieren</h1>

        <ng-container *ngIf="issuerManaged; else legacyOntologyManagement">
            <p class="read-only-note" *ngIf="!canManageIssuerCertification">
                Sie können Attestierungen und ausgestellte Zertifikate ansehen. Neue Attestierungen und Statusänderungen sind Organisations- oder Plattformadministratoren vorbehalten.
            </p>

            <section class="issuer-attestation-form" *ngIf="canManageIssuerCertification">
                <mat-form-field appearance="fill">
                    <mat-label>Organisationsauswahl</mat-label>
                    <mat-select [(value)]="selectedOrganisation" [disabled]="issuerLoading">
                        <mat-option *ngFor="let organisation of issuerOrganisations" [value]="organisation.organisationId">
                            {{ organisation.organisationName }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="issuerOrganisations.length === 0">
                        Alle verfügbaren Organisationen wurden bereits attestiert.
                    </mat-hint>
                </mat-form-field>

                <app-template-value-editor *ngIf="selectedOrganisation" [shapeJson]="certShape" [valueJson]="''"
                    (valueJsonChange)="onCertificateValuesChange($event)">
                </app-template-value-editor>

                <div class="mini-grid-buttons issuer-form-buttons" *ngIf="selectedOrganisation">
                    <button mat-raised-button color="primary" [disabled]="issuerLoading"
                        (click)="commitIssuerAttestation()">
                        Attestierung speichern
                    </button>
                    <button mat-stroked-button color="accent" [disabled]="issuerLoading"
                        (click)="selectedOrganisation = null; certificateValuesJson = ''">
                        Abbrechen
                    </button>
                </div>
            </section>

            <div class="issuer-table-heading">
                <p>Attestierungen und ausgestellte Zertifikate:</p>
                <button mat-icon-button color="primary" aria-label="Status aktualisieren" [disabled]="issuerLoading"
                    (click)="loadIssuerWorkflow(false)">
                    <mat-icon>refresh</mat-icon>
                </button>
            </div>
            <p class="issuer-error" *ngIf="issuerError">{{ issuerError }}</p>
            <div class="issuer-loading" *ngIf="issuerLoading"><mat-spinner diameter="28"></mat-spinner></div>

            <div class="table-container issuer-workflow-table" *ngIf="issuerWorkflows.length > 0; else noIssuerWorkflows">
                <div class="issuer-grid issuer-grid-header" [class.issuer-grid-readonly]="!canManageIssuerCertification">
                    <p class="grid_title">Organisation</p>
                    <p class="grid_title">Holder</p>
                    <p class="grid_title">Status</p>
                    <p class="grid_title">Aktualisiert</p>
                    <p class="grid_title">Grund</p>
                    <p class="grid_title">Werte (JSON)</p>
                    <p class="grid_title" *ngIf="canManageIssuerCertification">Aktionen</p>
                </div>
                <div class="issuer-grid" [class.issuer-grid-readonly]="!canManageIssuerCertification"
                    *ngFor="let workflow of issuerWorkflows">
                    <div class="grid_field">{{ workflow.organisationName || 'Nicht zugeordnet' }}</div>
                    <div class="grid_field holder-id">{{ workflow.holderId || '–' }}</div>
                    <div class="grid_field">
                        <span class="issuer-status" [ngClass]="issuerStatusClass(workflow.status)">
                            {{ workflow.status }}
                        </span>
                    </div>
                    <div class="grid_field">
                        {{ (workflow.issuedAt || workflow.createdAt) | date:'dd.MM.yyyy, HH:mm' }}
                    </div>
                    <div class="grid_field">{{ issuerWorkflowReason(workflow) }}</div>
                    <div class="grid_field">
                        <button mat-button color="primary" (click)="openIssuerValuesDialog(workflow)">
                            Werte anzeigen
                        </button>
                    </div>
                    <div class="grid_field action-cell issuer-actions" *ngIf="canManageIssuerCertification">
                        <ng-container *ngIf="workflow.trackedCredentialId; else noIssuerAction">
                            <button mat-stroked-button color="accent" *ngIf="workflow.status === 'ISSUED'"
                                [disabled]="issuerLoading" (click)="changeIssuerCredentialStatus(workflow, 'suspend')">
                                Suspendieren
                            </button>
                            <button mat-stroked-button color="primary" *ngIf="workflow.status === 'SUSPENDED'"
                                [disabled]="issuerLoading" (click)="changeIssuerCredentialStatus(workflow, 'resume')">
                                Fortsetzen
                            </button>
                            <button mat-stroked-button color="warn"
                                *ngIf="workflow.status === 'ISSUED' || workflow.status === 'SUSPENDED'"
                                [disabled]="issuerLoading" (click)="changeIssuerCredentialStatus(workflow, 'revoke')">
                                Widerrufen
                            </button>
                        </ng-container>
                        <ng-template #noIssuerAction><span class="no-action-label">Keine Aktion</span></ng-template>
                    </div>
                </div>
            </div>
            <ng-template #noIssuerWorkflows>
                <p class="issuer-empty" *ngIf="!issuerLoading">Für diese Credential Definition gibt es noch keine Attestierung.</p>
            </ng-template>
        </ng-container>

        <ng-template #legacyOntologyManagement>
            <mat-form-field appearance="fill">
                <mat-label>Organisationsauswahl</mat-label>
                <mat-select [(value)]="selectedOrganisation" (valueChange)="loadTableData()">
                    <mat-option *ngFor="let organisation of orgaList" [value]="organisation.id">
                        {{ organisation.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-template-value-editor *ngIf="selectedOrganisation" [shapeJson]="certShape" [valueJson]="''"
                (valueJsonChange)="onCertificateValuesChange($event)">
            </app-template-value-editor>

            <p>Bereits zertifizierte Organisationen:</p>
            <div class="table-container" *ngIf="certifiedOrganisationsForOntology.length > 0">
                <div class="grid_wrapper_6">
                    <p class="grid_title">Organisation</p>
                    <p class="grid_title">Status</p>
                    <p class="grid_title">Erstellt am</p>
                    <p class="grid_title">Geändert am</p>
                    <p class="grid_title">Werte (JSON)</p>
                    <p class="grid_title">Aktionen</p>
                </div>
                <ng-container *ngFor="let org of certifiedOrganisationsForOntology">
                    <div class="grid_wrapper_6">
                        <div class="grid_field">{{ org.organisationName }}</div>
                        <div class="grid_field">
                            <mat-chip-list>
                                <mat-chip [ngClass]="'status-' + org.status" [disabled]="true" [selectable]="false">
                                    {{ statusMapping[org.status] || (org.status | titlecase) }}
                                </mat-chip>
                            </mat-chip-list>
                            <button *ngIf="org.revocationReason" mat-icon-button color="warn"
                                (click)="showRevocationReason(org)" matTooltip="Grund anzeigen">
                                <mat-icon>info</mat-icon>
                            </button>
                        </div>
                        <div class="grid_field">{{ org.createdAt | humanReadableDate }}</div>
                        <div class="grid_field">{{ org.updatedAt | humanReadableDate }}</div>
                        <div class="grid_field">
                            <button mat-button color="primary" (click)="openOntologyValuesDialog(org)">Werte anzeigen</button>
                        </div>
                        <div class="grid_field action-cell">
                            <button *ngIf="org.status === 'ZURUECKGEZOGEN'" mat-raised-button color="accent"
                                (click)="reverseRevocation(org)">Wiederherstellen</button>
                            <button *ngIf="org.status === 'AKTIV'" mat-raised-button color="warn"
                                (click)="revokeCert(org)">Zurückziehen</button>
                            <span *ngIf="org.status !== 'ZURUECKGEZOGEN' && org.status !== 'AKTIV'"
                                class="no-action-label">Keine Aktion</span>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="mini-grid-buttons" *ngIf="selectedOrganisation">
                <button mat-raised-button color="primary" (click)="commitOntologyCertificationProcess()">Speichern</button>
                <button mat-stroked-button color="accent" (click)="cancelCertificationProcess()">Abbrechen</button>
            </div>
        </ng-template>
    </div>
    <div *ngIf="this.certType != 'ONTOLOGY_CERT'">
        <h1>Produkte zertifizieren</h1>

        <mat-form-field appearance="fill">
            <mat-label>Organisationsauswahl</mat-label>
            <mat-select [(value)]="selectedOrganisation" (valueChange)="this.loadTableData()">
                <mat-option *ngFor="let organisation of orgaList" [value]="organisation.id">
                    {{ organisation.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="table-container" *ngIf="this.selectedOrganisation">
            <div class="grid2_wrapper">
                <p class="grid_title">Zertifiziert</p>
                <p class="grid_title">Produkt</p>
                <p class="grid_title">Variante</p>
                <p class="grid_title">Version</p>
            </div>
            <ng-container *ngFor="let overview of this.overviewList">
                <div class="grid2_wrapper">
                    <div class="grid_checkbox">
                        <mat-checkbox [(ngModel)]="overview.hasCertification" (change)="localChange(overview)">
                        </mat-checkbox>
                    </div>
                    <div class="grid_field">{{ overview.productName }}</div>
                    <div class="grid_field">{{ overview.variantName }}</div>
                    <div class="grid_field">{{ overview.versionName }}</div>
                </div>
            </ng-container>
        </div>
        <!-- Checkbox Column -->

        <p>Bereits zertifizierte Produkte:</p>
        <div class="table-container">
            <div class="grid_wrapper_8">
                <p class="grid_title">Organisation</p>
                <p class="grid_title">Produkt</p>
                <p class="grid_title">Variante</p>
                <p class="grid_title">Version</p>
                <p class="grid_title">Erstelldatum</p>
                <p class="grid_title">Gültigkeit</p>
                <p class="grid_title">Status</p>
                <p class="grid_title">Aktionen</p>
            </div>
            <ng-container *ngFor="let overview of this.certifiedProductPage">
                <div class="grid_wrapper_8">
                    <div class="grid_field">{{ overview.organisation }}</div>
                    <div class="grid_field">{{ overview.productName }}</div>
                    <div class="grid_field">{{ overview.variantName }}</div>
                    <div class="grid_field">{{ overview.versionName }}</div>
                    <div [class]="{ highlight: overview.hasDateChanged }" class="grid_field_clickable"
                        (click)="picker.open()">
                        {{ overview.lastCertified | humanReadableDate }}
                        <i class="fa fa-calendar"></i>
                        <div style="width: 1px; visibility: hidden">
                            <input matInput ngModel="{{
                                overview.lastCertified | humanReadableDate
                            }}" (ngModelChange)="
                                updateProductCertificationDateValue(
                                    $event,
                                    overview
                                )
                            " [matDatepicker]="picker" />
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                    </div>
                    <div *ngIf="overview.validUntil != 'unbegrenzt'"
                        [class]="{ highlight: overview.hasHighlightValidUntil }" class="grid_field">
                        {{ overview.validUntil | humanReadableDate }}
                    </div>
                    <div *ngIf="overview.validUntil == 'unbegrenzt'"
                        [class]="{ highlight: overview.hasHighlightValidUntil }" class="grid_field">
                        {{ overview.validUntil }}
                    </div>
                    <div class="grid_field">
                        <mat-chip-list *ngIf="overview.status">
                            <mat-chip [ngClass]="'status-' + overview.status" [disabled]="true" [selectable]="false">
                                {{ statusMapping[overview.status] || (overview.status | titlecase) }}
                            </mat-chip>
                        </mat-chip-list>
                        <button *ngIf="overview.revocationReason" mat-icon-button color="warn"
                            (click)="dialogService.openWiderInfoDialog('Grund für das Zurückziehen', overview.revocationReason)" matTooltip="Grund anzeigen">
                            <mat-icon>info</mat-icon>
                        </button>
                    </div>
                    <div class="grid_field action-cell">
                        <button *ngIf="overview.status === 'AKTIV' || !overview.status" mat-raised-button color="warn"
                            (click)="revokeCert(overview)">
                            Zurückziehen
                        </button>
                        <button *ngIf="overview.status === 'ZURUECKGEZOGEN'" mat-raised-button color="accent"
                            (click)="reverseRevocation(overview)">
                            Wiederherstellen
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>
        <div>
            <p>Bereits zertifizierte nicht gelistete Produkte:</p>
            <div class="table-container">
                <div class="grid2_wrapper">
                    <p class="grid_title">Organisation</p>
                    <p class="grid_title">Produkt</p>
                    <p class="grid_title">Variante</p>
                    <p class="grid_title">Version</p>
                    <!--p class="grid_title">Gültigkeit</p-->
                </div>
                <ng-container *ngFor="let overview of this.certifiedNonListedProductPage">
                    <div class="grid2_wrapper">
                        <div class="grid_field">
                            {{ overview.organisationName }}
                        </div>
                        <div class="grid_field">{{ overview.productName }}</div>
                        <div class="grid_field">{{ overview.productVariant }}</div>
                        <div class="grid_field">{{ overview.variantVersion }}</div>
                        <!--div class="grid_field">
        {{ overview.validUntil | humanReadableDate }}
      </div-->
                    </div>
                </ng-container>
            </div>

            <div *ngIf="this.showNonListedProdCert">
                <h3>Nicht gelistete Produkte zertifizieren</h3>
                <div class="toggleswitchgrid">
                    <h4>Die Organisation existiert bereits auf der Plattform</h4>
                    <mat-slide-toggle class="toggleswitch" [(ngModel)]="this.toggleOrganisationSwitch"
                        (change)="cancelNonListedProductCertification(false)">
                    </mat-slide-toggle>
                </div>
                <div class="two-columns" *ngIf="this.toggleOrganisationSwitch">
                    <div class="not-listed-prod-grid-typography">
                        <h4>Organisation *</h4>
                        <h4>Produkt *</h4>
                        <h4>Variante *</h4>
                        <h4>Version *</h4>
                        <h4>Produkttyp*</h4>
                        <h4>E-Mail Adresse des Anbieters *</h4>
                    </div>
                    <div class="not-listed-prod-grid">
                        <mat-form-field (change)="this.findEmail()">
                            <mat-label required>Organisationsauswahl*</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let organisation of orgaList" [value]="organisation.id" (click)="
                                    this.orgaName = organisation.name;
                                    this.findEmail(organisation.id)
                                " required>
                                    {{ organisation.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Produkt" [(ngModel)]="productname" required />
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Variante" [(ngModel)]="productVariant" required />
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Version" [(ngModel)]="productVariantVersion" required />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label required>Produkttypauswahl*</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let productTyp of productType" (click)="
                                    this.prodType = productTyp; setProductType()
                                " [value]="this.prodType">
                                    {{ productTyp }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="E-Mail Adresse des Anbieters" [(ngModel)]="emailofOrga"
                                required />
                        </mat-form-field>
                    </div>
                    <div>
                        <h4>* ... - Pflichtfelder</h4>
                    </div>
                </div>
                <div class="two-columns" *ngIf="!this.toggleOrganisationSwitch">
                    <div class="not-listed-prod-grid-typography">
                        <h4>Organisation *</h4>
                        <h4>Produkt *</h4>
                        <h4>Variante *</h4>
                        <h4>Version *</h4>
                        <h4>Produkttyp *</h4>
                        <h4>E-Mail Adresse des Anbieters *</h4>
                    </div>
                    <div class="not-listed-prod-grid">
                        <mat-form-field>
                            <input matInput placeholder="Organisation" [(ngModel)]="orgaName" required />
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Produkt" [(ngModel)]="productname" required />
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Variante" [(ngModel)]="productVariant" required />
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="Version" [(ngModel)]="productVariantVersion" required />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label required>Produkttypauswahl*</mat-label>
                            <mat-select>
                                <mat-option *ngFor="let productTyp of productType" (click)="
                                    this.prodType = productTyp; setProductType()
                                " [value]="this.prodType">
                                    {{ productTyp }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="E-Mail Adresse des Anbieters" [(ngModel)]="emailofOrga"
                                required />
                        </mat-form-field>
                    </div>
                    <div>
                        <h4>* ... - Pflichtfelder</h4>
                    </div>
                </div>
                <div *ngIf="this.error" (change)="(this.error)">
                    <h4 class="errorTitle">{{ this.undefinedVariable }}</h4>
                </div>
            </div>
        </div>

        <div *ngIf="!this.showNonListedProdCert" class="mini-grid-buttons">
            <button mat-raised-button color="primary" class="certbutton" (click)="this.showNonListedProdCertOptions()">
                Nicht gelistete Produkte zertifizieren
            </button>
        </div>

        <div *ngIf="this.showNonListedProdCert" class="mini-grid-buttons">
            <button mat-raised-button color="primary" (click)="this.submitNonListedProductCertification()">
                Hinzufügen
            </button>

            <button mat-stroked-button color="accent" (click)="this.cancelNonListedProductCertification(true)">
                Abbrechen
            </button>
        </div>
        <div *ngIf="!this.showNonListedProdCert" class="mini-grid-buttons">
            <button mat-raised-button color="primary" (click)="this.commitCertificationProcess()">
                Speichern
            </button>
            <button mat-stroked-button color="accent" (click)="this.cancelCertificationProcess()">
                Abbrechen
            </button>
        </div>
    </div>


</div>
